import { smsNotificationServiceEnvironment } from '../sms-notification-service-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { withJwt } from '../../../utils/with-jwt';
import { selectBlob } from '../../../utils/select-blob';
import { fromFetch } from 'rxjs/fetch';

export function postQrCode(
  this: unknown,
  params: { url: string; numberOfPixels: number }
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${smsNotificationServiceEnvironment.resolve(this).qrCodeUrl}`,
        {
          method: 'POST',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
          body: JSON.stringify(params),
        }
      )
    )
  ).pipe(selectBlob());
}
